<template>
  <refonte-modal
    v-bind:show="props.show"
    class="refonte-modal-container h-full !max-w-[768px]"
    modal_body_class="map-modal_body--overflow-y h-full p-0"
    v-bind:no_close_btn="true"
    v-on:close="close">
    <template v-slot:modalHeader>
      <div
        class="refonte-modal-header-container flex w-full items-start justify-between lg:flex-wrap lg:items-center">
        <div class="flex-grow text-left">
          <h1 class="mb-1 text-xl">Géolocalisation</h1>
          <p class="text-sm">{{ adresse }}</p>
        </div>
        <refonte-button
          variant="secondary"
          v-on:click="flyToCoordinates">
          Re-centrer la carte
        </refonte-button>
        <div
          class="refonte-modal-header-close"
          v-on:click.prevent.stop="() => on_close()">
          <IconClose />
        </div>
      </div>
    </template>
    <template v-slot:modalBody>
      <div
        id="map"
        class="h-full"></div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import IconClose from '@/assets/img/refonte/icons/display/icon-close.svg?component';
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import { nextTick, ref, watch } from 'vue';
  import mapboxgl from 'mapbox-gl';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      adresse: string;
      coordinates: string;
    }>(),
    {
      class: '',
      show: false
    }
  );

  const mapStyle =
    'https://openmaptiles.geo.data.gouv.fr/styles/osm-bright/style.json';

  const currentMap = ref();

  watch(
    () => props.show,
    async (value) => {
      await nextTick(() => {
        if (value) {
          initMap();
        }
      });
    },
    { immediate: true }
  );

  const initMap = async () => {
    mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN_API;

    const scale = new mapboxgl.ScaleControl({
      maxWidth: 80,
      unit: 'metric'
    });
    const coordinates = props.coordinates.split(',') as unknown as [
      number,
      number
    ];
    const map = new mapboxgl.Map({
      container: 'map',
      style: mapStyle,
      center: coordinates,
      zoom: 14
    })
      .addControl(new mapboxgl.NavigationControl())
      .addControl(new mapboxgl.FullscreenControl())
      .addControl(scale);
    // Create a default Marker and add it to the map.

    new mapboxgl.Marker().setLngLat(coordinates).addTo(map);

    currentMap.value = map;
  };

  const flyToCoordinates = () => {
    const coordinates = props.coordinates.split(',') as unknown as [
      number,
      number
    ];

    currentMap.value.flyTo({
      center: coordinates,
      zoom: 14
    });
  };

  function close() {
    props.on_close();
  }
</script>

<style lang="scss" scoped>
  :deep(.refonte-modal-container) {
    @apply overflow-hidden p-0;
  }
  :deep(.refonte-modal-header-container) {
    padding: 32px;
    padding-bottom: 0px;
  }

  .refonte-modal-header-close {
    @apply absolute flex cursor-pointer items-center justify-center;
    top: 10px;
    right: 10px;
    width: 26px;
    height: 26px;

    :deep(svg) {
      @apply text-refonte-black;
      width: 10px;
      height: 10px;
    }

    &:hover {
      :deep(svg) {
        @apply text-refonte-black-60;
      }
    }
  }
</style>
